import {createRouter, createWebHistory} from 'vue-router'
import Home from '@/pages/Home'
import Meeten from '@/pages/media/Meeten.vue'
import Subscribe from '@/pages/Subscribe.vue'
import SignIn from '@/pages/SignIn.vue'
import SignUp from '@/pages/SignUp.vue'
import Pay from '@/pages/Pay'
import PrivacyPolicy from '@/components/PrivacyPolicy'
import store from '@/store/store'
import EventEmitter from '@/utils/eventEmitter'
import Authorize from '@/components/Authorize'
import Jozzy from "@/pages/media/Jozzy.vue";

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/subscribe',
        name: 'subscribe',
        component: Subscribe
    },
    {
        path: '/pay',
        name: 'pay',
        component: Pay
    },
    {
        path: '/signin',
        name: 'signin',
        component: SignIn
    },
    {
        path: '/authorize',
        name: 'authorize',
        component: Authorize
    },
    {
        path: '/signup',
        name: 'signup',
        component: SignUp
    },
    {
        path: '/privacy-policy',
        name: 'privacyPolicy',
        component: PrivacyPolicy
    },
    {
        path: '/meeten',
        name: 'meeten',
        component: Meeten
    },
    {
        path: '/jozzy',
        name: 'jozzy',
        component: Jozzy
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        setTimeout(() => {
            document.getElementById('app').scrollIntoView({ behavior: 'instant' })
        }, 300)
    }
})

function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

router.beforeEach(async (to, from) => {

    if(to.query.ref) {
        localStorage.setItem('ref', to.query.ref)
    }

    console.log('Route to', to, store.state.user)
    if(!store.state.user && localStorage.getItem('hash')) {
        // this.loading = true
        try {

            // await timeout(3000)

            const response = await fetchServer('/auth', {
                sessionHash: localStorage.getItem('hash')
            })

            if(response['err']) {
                // this.loading = false
                console.log(response['err'])
                alert(response['err'])
                return false
            }

            if(response['internalError']) {
                // this.loading = false
                console.log(response['internalError'])
                alert('Ошибка авторизации! Попробуйте позже')
                return false
            }

            if(response['logout']) {
                localStorage.removeItem('hash')
                store.state.user = null
            } else {
                store.state.user = response['user']
                console.log('User', response['user'])
            }

            return true

            // this.loading = false

        } catch (e) {
            // this.loading = false
            console.log(e)
            alert('Ошибка авторизации! Попробуйте позже')
            return false
        }
    } else if(!localStorage.getItem('hash')) {
        store.state.user = null
        console.log('User = null')
    }

    if(to.path.startsWith('/signin') && localStorage.getItem('hash')) {
        return false
    }

    if((to.name === 'pay' || to.name === 'subscribe') && !store.state.user) {
        return { path: '/signin', query: { return_url: to.fullPath } }
    }

    return true
})

export default router
